import { useMutation } from '@tanstack/react-query';

import { QuizService } from './quizService';

export function useSubmitQuiz(quizId: string, attemptId: string) {
  return useMutation({
    mutationFn: () => QuizService.submitQuiz(quizId, attemptId).then((response) => response.data),
  });
}
